import { Menu, Tooltip, Text } from '@mantine/core';

export type ActionMenuItemProps = {
    icon: React.ReactNode;
    label: string;
    onClick: () => void;
    tooltip?: string;
    disabled?: boolean;
};

export function ActionMenuItem({ icon, label, onClick, tooltip, disabled = false }: ActionMenuItemProps) {
    return (
        <Menu.Item
            leftSection={icon}
            onClick={onClick}
            disabled={disabled}
        >
            {tooltip ? (
                <Tooltip label={tooltip}>
                    <Text>{label}</Text>
                </Tooltip>
            ) : (
                <Text>{label}</Text>
            )}
        </Menu.Item>
    );
}
